module.exports = __webpack_public_path__ + "static/shorter-way-e11aab8d37d3c2faff1cd26379c71fb8.jpg";